var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"process-progress-bar"},_vm._l((_vm.options),function(option,index){return _c('div',{key:option,class:{
      'process-progress-bar__item': true,
      'process-progress-bar__item--active': index <= _vm.currentItemIndex,
      'process-progress-bar__item--complete':
        index < _vm.currentItemIndex || _vm.currentItemIndex === _vm.options.length - 1
    }},[_c('div',{staticClass:"process-progress-bar__number"},[_vm._v(_vm._s(index + 1))]),_c('div',{staticClass:"process-progress-bar__text"},[_vm._v(_vm._s(option))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }